import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { atxIsDesktop$ } from '@epicuro-next/ataraxia/breakpoint';
import { faThinPin, faThinUnpin } from '@epicuro-next/ataraxia/icons';
import {
  NAMESPACE_NEWS_FEED,
  NewsfeedConfigurationKeys,
} from '@epicuro-next/state/news-feed-state';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'epc-feed-article-overlay',
  templateUrl: './feed-article-overlay.component.html',
  styleUrls: ['./feed-article-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FeedArticleOverlayComponent {
  public faThinPin = faThinPin;
  public faThinUnpin = faThinUnpin;
  public pinText = $localize`:FeedArticlePreview|Pin item tooltip@@pinItemTooltip:Pin item`;
  public unpinText = $localize`:FeedArticlePreview|Unpin item tooltip@@unpinItemTooltip:Unpin item`;
  public deleteText = $localize`:FeedArticlePreview|Delete item tooltip@@deleteItemTooltip:Delete item`;
  public pinLookbookText = $localize`:FeedArticlePreview|Pin lookbook item tooltip@@pinLookbookItemTooltip:Pin lookbook`;
  public deleteLookbookText = $localize`:FeedArticlePreview|Delete Lookbook item tooltip@@deleteLookbookItemTooltip:Delete Lookbook`;
  public unpinLookbookText = $localize`:FeedArticlePreview|Unpin lookbook item tooltip@@unpinLookbookItemTooltip:Unpin lookbook`;
  private visiblePins$$ = new BehaviorSubject(false);
  public visiblePins$ = combineLatest([this.visiblePins$$, atxIsDesktop$]).pipe(
    map(([visiblePin, isDesktop]) => (isDesktop ? visiblePin : true)),
  );
  public newsfeedNamespace = NAMESPACE_NEWS_FEED;
  public enableNewsfeedDelete = NewsfeedConfigurationKeys.EnableNewsfeedDelete;

  @Input()
  public isLookbook = false;

  @Input()
  public hasPowerList = false;

  @Input()
  public isVideo: boolean;

  @Input()
  public isDirectShow: boolean;

  @Input()
  public showPins = false;

  @Input()
  public showBin = false;

  @Input()
  public isPinned: boolean;

  @Input()
  public hasCommercialList: boolean;

  @Input()
  @HostBinding('class.active')
  public isActive: boolean;

  @Input()
  public title: string;

  @Input()
  public set visiblePins(value: boolean) {
    this.visiblePins$$.next(value);
  }

  @Input()
  public referenceId: string;

  @Input()
  public referenceIds: string[];

  @Input()
  public isShowIndicator = true;

  @Output()
  public togglePinState = new EventEmitter<boolean>();

  @Output()
  public clicked = new EventEmitter<MouseEvent>();

  @Output()
  public delete = new EventEmitter<MouseEvent>();

  public clickListener(event: MouseEvent) {
    this.clicked.emit(event);
  }
}
